import { AritoDialog, AritoForm, AritoHeaderTabs, AritoIcon, BottomBar } from '@/components/custom/erp';
import { detailInitialValues, DetailTemplateSchema } from '../../schema';
import useInputTableRow from './tabs/InputTableTab/useInputTableRow';
import { isValidUUID } from '@/lib/uuid-validator';
import { useSearchFieldStates } from '../../hooks';
import InputTableTab from './tabs/InputTableTab';
import type { TaiKhoan } from '@/types/schemas';
import { GeneralTab } from './tabs/GeneralTab';
import { BasicInfo } from './tabs/BasicInfo';

interface DetailFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  mode: 'add' | 'edit' | 'view';
  initialData?: any;
}

const DetailFormDialog: React.FC<DetailFormDialogProps> = ({ open, onClose, onSave, mode, initialData }) => {
  const searchFieldStates = useSearchFieldStates(initialData);

  const {
    rows,
    handleRowClick,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    handleCellValueChange
  } = useInputTableRow(initialData?.dieu_kien_khac_data || []);
  const tabs = [
    {
      id: 'general',
      label: 'Thông tin chung',
      component: <GeneralTab mode={mode} searchFieldStates={searchFieldStates} />
    },
    {
      id: 'condition',
      label: 'Điều kiện khác',
      component: (
        <InputTableTab
          mode={mode}
          rows={rows}
          onRowClick={handleRowClick}
          onAddRow={handleAddRow}
          onDeleteRow={handleDeleteRow}
          onCopyRow={handleCopyRow}
          onPasteRow={handlePasteRow}
          onMoveRow={handleMoveRow}
          onCellValueChange={handleCellValueChange}
        />
      )
    }
  ];

  const onSubmit = (data: any) => {
    const transformData = {
      ...data,
      tk: searchFieldStates.taiKhoan?.map((item: TaiKhoan) => item.code),
      tk_gt: searchFieldStates.taiKhoanGiamTru?.map((item: TaiKhoan) => item.code),
      tk_du: searchFieldStates.taiKhoanDoiUng?.map((item: TaiKhoan) => item.code),
      dieu_kien_khac: rows.map((row: any, index: number) => ({
        ...(isValidUUID(row.uuid) && mode !== 'add' ? { uuid: row.uuid } : {}),
        line: index + 1,
        id_dt_loc: row.id_dt_loc,
        ds_loc: row.ds_loc?.map((item: any) => (typeof item === 'string' ? item : item.uuid || item.code || item))
      }))
    };
    console.log('rows', rows);
    onSave(transformData);
  };

  return (
    <AritoDialog
      open={open}
      onClose={onClose}
      title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
      titleIcon={<AritoIcon icon={281} />}
      zIndex={110}
    >
      <div onSubmit={e => e.stopPropagation()} className='max-h-[80vh] min-w-[900px] bg-gray-50'>
        <AritoForm
          mode={mode}
          initialData={initialData || detailInitialValues}
          onSubmit={onSubmit}
          schema={DetailTemplateSchema}
          hasAritoActionBar={false}
          headerFields={
            <>
              <BasicInfo />

              <AritoHeaderTabs tabs={tabs} />
            </>
          }
          bottomBar={<BottomBar onClose={onClose} mode={mode} />}
        />
      </div>
    </AritoDialog>
  );
};

export default DetailFormDialog;
